// 存档层常量 —— 全项目唯一允许定义版本号与键名的地方（架构 §7.2 / ADR-002 §2.1）。
// 除本文件外，任何其它模块不得再写字面量 `2` 作为存档版本，也不得再定义 STORAGE_KEY。

// ★ 仅此一处定义当前 schema 版本；其它文件通过 import 引用，不写字面量。
// v2：mailbox 字段引入（P-POSTCARD-RECONCEIVE），v1 旧档经 migrate v1→v2 补 mailbox + 去重键。
export const CURRENT_SCHEMA_VERSION = 2;

// localStorage 主键名（ADR-002 §2.1，§13-B 待批准项按「建议批准」落地）。
export const STORAGE_KEY = 'dogtrip.save';

// 损坏存档备份键前缀；完整键 = `${BACKUP_KEY_PREFIX}${Date.now()}`（ADR-002，命名见不一致登记 E：点分隔）。
export const BACKUP_KEY_PREFIX = 'dogtrip.save.backup.';
